// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"8b95d20b","565":"ea6f730b"}[chunkId] + ".chunk.css";
};